module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAmklEQVR4nO3PQQ7CIBQE0EH31SN4EQ0p3Ysnsp5I3JeG6EU8gnavOF2U2ADGpNu+1fyfnwkITDQXJAp2ZVl74MgY4fHp2rY1vnA3JrVev7vu7oEVx4CHz0VRbJwxD44B9zGplH55f2YMlkIcnLWGcSRZ0NsqZeD9npFX4nKzVjNFsgXDV0Cppw+yBT1ZVRLkmsYh42fBP+YC4ANJhysRWU52WQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/img-jiantou.png
// module id = 214
// module chunks = 45